import React from "react";
import Button from "@mui/material/Button";
import { withLocalizer } from "utilities/withLocalizer";

function PreviousButton(props) {
    let { data, events } = props;
    let { currentStep } = data;

    if (currentStep === 1 || currentStep === 7) return;

    return (
        <div className="wizard-button pull-left">
            <Button className="btn-blue-white" data-testid="info-btn" variant="contained" onClick={ events?.previous }>
                {props.localize("qma-navigation-back")}
            </Button>
        </div >
    );
}

export default withLocalizer(PreviousButton);